const state = {
    signalLabels: { vehiclePos: "Vehicle position [m]", bicyclePos: "Bicycle position [m]", bp: "Brake pedal deflection [0-1]", exActivity: "Excitatory activity", exCue: "Excitatory cue (Longitudinal looming) [1/s]", exPr: "Excitatory received perceptual quantity", exPp: "Excitatory predicted perceptual quantity", inActivity: "Inhibitory activity", inCue: "Inhibitory cue (PET_proj) [s]", inPr: "Inhibitory received perceptual quantity", inPp: "Inhibitory predicted perceptual quantity" },
    signalsToPlot: ["vehiclePos", "bicyclePos"], // String array
    signalColors: { vehiclePos: "ff4000", bicyclePos: "aef321", bp: "f49598", exActivity: "85dcffff", exCue: "85dcffff", exPr: "85dcffff", exPp: "85dcffff", inActivity: "ffd430ff", inCue: "ffd430ff", inPr: "ffd430ff", inPp: "ffd430ff" },
    signalBorderDashes: { vehiclePos: [], bicyclePos: [], bp: [], exActivity: [], exCue: [10, 10], exPr: [20, 5, 5, 5], exPp: [5, 10], inActivity: [], inCue: [10, 10], inPr: [20, 5, 5, 5], inPp: [5, 10] },
    type: "line",
    data: {
        labels: [],
        datasets: []
    },
    options: {
        plugins: {
            zoom: {
                // Container for pan options
                pan: {
                    // Boolean to enable panning
                    enabled: true,

                    // Panning directions. Remove the appropriate direction to disable
                    // Eg. 'y' would only allow panning in the y direction
                    mode: 'xy'
                },

                // Container for zoom options
                zoom: {
                    // Boolean to enable zooming
                    enabled: true,

                    // Zooming directions. Remove the appropriate direction to disable
                    // Eg. 'y' would only allow zooming in the y direction
                    mode: 'xy',
                }
            }
        },
        elements: {
            point: {
                radius: 0
            }
            ,
            line: {
            }
        },
        layout: { padding: { bottom: 0 } },
        animation: false,
        legend: {
            onClick: null,
            labels: {
                fontColor: "white",
                fontSize: 18
            }
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
            yAxes: [{
                gridLines: { color: 'whitesmoke', zeroLineColor: "whitesmoke" },
                ticks: {
                    beginAtZero: true,
                    fontColor: "whitesmoke",
                    maxTicksLimit: 5,
                    fontSize: 20,
                    padding: 10
                }
            }],
            xAxes: [{
                scaleLabel: { display: true, labelString: "Time [s]", fontColor: "whitesmoke", fontSize: 25 },
                gridLines: { color: 'whitesmoke', zeroLineColor: "whitesmoke" },
                ticks: {
                    beginAtZero: true,
                    fontColor: "whitesmoke",
                    maxTicksLimit: 5,
                    fontSize: 20,
                    padding: 10
                }
            }]
        }
    }
}

// getters
const getters = {}

// actions
const actions = {
    updateData: function (store, signals) {
        const data = {
            labels: [],
            datasets: []
        };
        const floatPrecision = 10 ** 2;
        const signalsToPlot = store.state.signalsToPlot;
        signalsToPlot.forEach(signalName => {
            const localDataset = {
                label: store.state.signalLabels[signalName], data: [], backgroundColor: "rgba(0,0,0,0)", borderColor: "#" + store.state.signalColors[signalName], borderDash: store.state.signalBorderDashes[signalName], cubicInterpolationMode: "monotone",
                borderWidth: 3,
            };
            signals.forEach((signalEl, i) => {
                if (i !== 0) {
                    localDataset.data.push({ x: Math.round(signalEl["t"] * floatPrecision) / floatPrecision, y: Math.round(signalEl[signalName] * floatPrecision) / floatPrecision });
                }
            });
            data.datasets.push(localDataset);
        });
        var localLabels = [];
        signals.forEach((signalEl, i) => {
            if (i !== 0) {
                localLabels.push(Math.round(signalEl["t"] * floatPrecision) / floatPrecision);
            }
        });
        data.labels = localLabels;
        store.state.data = data;
    }
}

// mutations
const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}